import APP from '../../../main.js'
import AppRecord from './AppRecord.js'

class MailGroupAction extends AppRecord {

}
export default MailGroupAction
